/**
 * External dependencies
 */
import { View } from 'react-native';

export default ( props ) => <View>{ props.children }</View>;
